<!--
 * @Author: your name
 * @Date: 2021-09-26 21:29:54
 * @LastEditTime: 2022-05-18 18:12:18
 * @LastEditors: lsr lsr@qq.com
 * @Description: 注册易伙伴
 * @FilePath: \h5-vip\src\pages\registered\index.vue
-->
<template>
	<div class="app-container" :style="{ minHeight: height }">
		<img class="logoImg" src="@/assets/logobai.png" alt="" />
		<div class="box">
			<van-form @submit="onSubmit" label-width="60px" label-align="right">
				<div class="title">
					<b style="fontSize: 18px; color: #eb7c45">{{ Invitee }}</b>
					邀请您加入易伙伴
				</div>
				<van-field v-model="form.upReferKey" name="upReferKey" label="邀 请 码" placeholder="请填邀请码" :rules="rules.upReferKey" />
				<van-field v-model="form.phoneNumber" maxlength="11" label="手 机 号" name="phoneNumber" placeholder="请填手机号" :rules="rules.phoneNumber"></van-field>
				<van-field v-model="form.verificationCode" name="verificationCode" maxlength="6" label="验 证 码" placeholder="请输入验证码" :rules="rules.verificationCode">
					<template #button>
						<van-button class="code" size="small" :disabled="flag" color="#f2473d" round v-if="flag">{{ time }}秒后获取</van-button>
						<van-button v-else native-type="button" size="small" color="#f2473d" round @click="goCode">获取验证码</van-button>
					</template>
				</van-field>
				<van-field
					v-model="form.password"
					name="password"
					label=" 密  码 "
					:right-icon="eye1"
					@click-right-icon="closed1"
					:type="pass1"
					placeholder="请输入密码"
					:rules="rules.password"
				/>
				<van-field
					v-model="form.confirmPassword"
					:right-icon="eye2"
					@click-right-icon="closed2"
					:type="pass2"
					name="confirmPassword"
					label="确认密码"
					placeholder="请输入确认密码"
					:rules="rules.confirmPassword"
				/>
				<div style="margin: 16px">
					<van-button round block color="#f2473d" native-type="submit" :disabled="isDisabled">立 即 加 入</van-button>
			<!-- 		<div class="download" @click="download">下载APP</div> -->
				</div>
			</van-form>
		</div>

		<div class="content" ref="content"></div>
		<div class="agreement">
			<van-checkbox v-model="checkbox" checked-color="#de7423" shape="round"><span class="van-checkbox">阅读并同意</span></van-checkbox>
			<span class="check" @click="goAgreement">《易伙伴隐私政策》</span>
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant';
import { register, getCode, downloadApp } from '@/api/index';
export default {
	name: '',
	data() {
		return {
			form: {
				phoneNumber: '',
				upReferKey: '',
				verificationCode: '',
				password: '',
				confirmPassword: ''
			},
			Invitee: '',
			checkbox: '',
			rules: {
				phoneNumber: [
					{ required: true, message: '' },
					{
						pattern: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
						message: '请输入正确的手机号'
					}
				],
				password: [{ required: true, message: '' }],
				confirmPassword: [{ required: true, message: '' }],
				verificationCode: [{ required: true, message: '' }],
				upReferKey: [{ required: true, message: '' }]
			},
			flag: false,
			time: null,
			browser: false,
			pass1: 'password',
			pass2: 'password',
			eye1: 'closed-eye',
			eye2: 'closed-eye',

			// 注册按钮防抖
			isDisabled: false,

			height: ''
		};
	},
	//在生命周期中获取，在方法中写法相同
	created() {
		this.$nextTick(() => {
			this.height = document.documentElement.clientHeight + 'px';
			// console.log("heigth", this.height);
			console.log(this.$refs.content.offsetHeight);
		});
		this.Invitee = this.$route.query.realName;
		this.form.upReferKey = this.$route.query.code;
		this.getisweixing();
		// if (this.browser) {
		//   Toast({
		//       message: "请点击右上角选择在浏览器中打开",
		//       duration: 3000,
		//     });
		// }
	
	},
	methods: {
		closed1() {
			// console.log(11);
			if (this.pass1 == 'password') {
				this.pass1 = 'text';
				this.eye1 = 'eye-o';
			} else {
				this.pass1 = 'password';
				this.eye1 = 'closed-eye';
			}
		},
		closed2() {
			if (this.pass2 == 'password') {
				this.pass2 = 'text';
				this.eye2 = 'eye-o';
			} else {
				this.pass2 = 'password';
				this.eye2 = 'closed-eye';
			}
		},
		// 判断是否在 微信浏览器
		getisweixing() {
			var wx = window.navigator.userAgent.toLowerCase();
			if (wx.match(/MicroMessenger/i) == 'micromessenger') {
				// console.log('是微信浏览器默认走微信')
				this.browser = true;
				return true; // 是微信端
			} else {
				// console.log('不是微信浏览器绘制原生。');
				this.browser = false;
				return false;
			}
		},

		// 获取验证码
		async goCode() {
			// if (this.browser) {
			//   Toast({
			//     message: "请点击右上角选择在浏览器中打开",
			//     duration: 3000,
			//   });
			//   return;
			// }
			if (this.form.phoneNumber.trim().length < 11) {
				Toast('请填写正确的手机号');
				return;
			}

			this.time = 60;
			let ti = null;
			this.flag = true;
			ti = setInterval(() => {
				this.time--;
				// console.log(this.time);
				if (this.time <= 1) {
					clearTimeout(ti);
					this.flag = false;
					return;
				}
			}, 1000);

			await getCode(this.form.phoneNumber).then(res => {
				if (res.code != 200) {
					Toast(res.msg);
					return;
				}
				Toast('验证码已发送');
			});
		},

		// 注册事件
		async onSubmit(values) {
			if (this.form.password.trim().length < 6) {
				Toast('密码长度不能小于6位');
				return;
			}
			if (!this.checkbox) {
				Toast('请阅读并同意协议');
				return;
			}

			if (this.form.confirmPassword != this.form.password) {
				Toast('两次密码不一致！');
				return;
			}
			let data = {
				...this.form
			};
			this.isDisabled = true;
			await register(data)
				.then(res => {
					if (res.code != 200) {
						Toast({
							message: res.msg
						});
						this.isDisabled = false;
						return;
					}
					this.$toast({
						message: '注册成功，欢迎加入易伙伴~',
						duration: '3000'
					});
					var that = this;
					setTimeout(function() {
						that.$nextTick(() => {
							that.$router.push('/download');
						});
					}, 1500);
					this.isDisabled = false;
				})
				.catch(err => {
					console.log('erre', err);
				});
		},

		//  协议
		goAgreement() {
			if (this.browser) {
				Toast({
					message: '请点击右上角选择在浏览器中打开',
					duration: 3000
				});
				return;
			}
			this.$router.push('/agreement');
		},

		// 下载app
		async download() {
			if (this.browser) {
				Toast({
					message: '请点击右上角选择在浏览器中打开',
					duration: 3000
				});
				return;
			}
			await downloadApp().then(res => {
				let u = navigator.userAgent;
				let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
				if (isAndroid) {
					window.location.href = res.msg;
				} else {
					window.location.href = `itms-apps://itunes.apple.com/app/id1587458887`;
				}
			});
		}
	}
};
</script>

<style scoped>
.app-container {
	position: relative;
	width: 100vw;
	display: flex;
	background-color: #da222c;
	flex-direction: column;
	justify-content: space-between;
}

.logoImg {
	width: 173.4px;
	height: 51.5px;
	margin: 8% auto 10px auto;
}

.box {
	width: 85%;
	background-color: #fff;
	border-radius: 25px;
	box-shadow: 0px 0px 40px rgba(153, 66, 22, 1);

	margin: 10px auto;
}
.box .van-cell {
	align-items: center;
}
.title {
	text-align: center;
	margin: 10px 0;
	padding: 10px 0;
	font-weight: 600;
	letter-spacing: 1px;
}

.slot {
	background-color: #000000;
}

.content {
	width: 100%;
	height: 95%;
}

.agreement {
	display: flex;
	justify-content: center; /* 水平居中 */
	align-items: center;
	width: 100vw;
	margin-top: 12px;
	margin-bottom: 20px;
	text-align: center;
	z-index: 0;
	background-color: #da222c !important;
	color: #ffffff;
	/* line-height: 35.8px; */
	font-size: 16px;
	line-height: 0;
}
.agreement /deep/.van-checkbox__icon {
	font-size: 16px;
}
.van-checkbox {
	color: #ffffff;
}

.checkbox {
	vertical-align: middle;
	margin-top: 0;
	padding-right: 10px;
}

/* 下载 */
.download {
	width: 100%;
	height: 40px;
	line-height: 40px;
	text-align: center;
	margin: auto;
	margin-top: 15px;
	background-color: #eb7c45;
	border-radius: 20px;
	color: #ffffff;
}
</style>
